/* eslint 'jsx-a11y/alt-text': 'off', eqeqeq: 'off' */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { Label, Button } from 'reactstrap';
import NoImage from '../../../../../Assets/images/NoImage.jpg';
import '../../../../../Assets/EnsembleStyles/CustomiseInvoice.css';
import { GetInvoiceTemplate,PutInvoiceTemplate,PostInvoiceLogo,GetInvoiceLogo } from '../../../../../action/invoiceAction';
import { getUserPreferences } from '../../../../../action/cultureAction';


class CustomiseInvoices extends Component {

    componentDidMount() {
        this.props.GetInvoiceLogo();
         this.props.getUserPreferences();
         this.props.GetInvoiceTemplate();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
        
             if( nextProps.response_from_reducer.InvoiceTemplate !== false && nextProps.response_from_reducer.InvoiceTemplate.length !==0 ){
                 //var url = nextProps.response_from_reducer.InvoiceTemplate.logoSrc;
                 //var filename = url.substring(url.lastIndexOf('/')+1);
                this.setState({
                    invoiceSetupId: nextProps.response_from_reducer.InvoiceTemplate.invoiceSetupId,
                    invoice_number_preview: nextProps.response_from_reducer.InvoiceTemplate.invoicePrefix,
                    payment_remit_to: nextProps.response_from_reducer.InvoiceTemplate.remitToAddress,
                    custom_text_above: nextProps.response_from_reducer.InvoiceTemplate.aboveInvoiceText,
                    custom_text_below: nextProps.response_from_reducer.InvoiceTemplate.belowInvoiceText,
                },()=>{
                 
                    if(this.state.custom_text_above ==""){
                        this.setState({   placeholder_invoice_number_preview:nextProps.getLabels['InoviceSetup.Prefix.Text'], });
                    }
                    if(this.state.custom_text_above ==""){
                        this.setState({  placeholder_payment_remit_to:"Property Mgmt Company Contact Name Street Address City, ST ZIP", });
                    }
                    if(this.state.custom_text_above ==""){
                        this.setState({  placeholder_custom_text_above:nextProps.getLabels['InoviceSetup.AboveInvValue.Text'] });
                    }
                    if(this.state.custom_text_above ==""){
                        this.setState({   placeholder_custom_text_below:nextProps.getLabels['InoviceSetup.BelowInvValue.Text']});
                    }
                }
            );
             }
             else if(nextProps.response_from_reducer.InvoiceTemplate === false){
                this.setState({
                    placeholder_image_name:nextProps.getLabels['InoviceSetup.BrowseImage.Text'],
                    placeholder_invoice_number_preview:nextProps.getLabels['InoviceSetup.Prefix.Text'],
                    // placeholder_payment_remit_to:nextProps.getLabels['InoviceSetup.Company.Text'+'InoviceSetup.ContactPerson.Text'+'InoviceSetup.StreetAddress.Text'+'InoviceSetup.City.Text'+'InoviceSetup.StateZip.Text'],
                    placeholder_payment_remit_to:"Property Mgmt Company Contact Name Street Address City, ST ZIP",
                    placeholder_custom_text_above:nextProps.getLabels['InoviceSetup.AboveInvValue.Text'],
                    placeholder_custom_text_below:nextProps.getLabels['InoviceSetup.BelowInvValue.Text'],
             
                });
            }
             if(nextProps.response_from_reducer.Invoicelogo != null){
                 this.setState({
                    imagePreviewUrl: nextProps.response_from_reducer.Invoicelogo
                });
             }
            //  if(nextProps.response_from_reducer.PostInvoiceLogo === true ){
            //     this.setState({
            //         PrepareInvoiceRedirect: true
            //     });
            // }
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            Template_data_from_api : null,
            Template_data_from_resource : null,

            file: '',
            image_name: '',
            imagePreviewUrl: '',
            invoiceSetupId:'',
            invoice_number_preview: '',
            payment_remit_to: '',
            custom_text_above: '',
            custom_text_below: '',
            placeholder_image_name :'',
            placeholder_invoice_number_preview :'',
            placeholder_payment_remit_to :'',
            placeholder_custom_text_above :'',
            placeholder_custom_text_below :'',
            PrepareInvoiceRedirect: false
        };
        this.Save_Invoice_Template = this.Save_Invoice_Template.bind(this);
        this.PrepareInvoice = this.PrepareInvoice.bind(this);
    }



       
    Save_Invoice_Template() {

        let {  image_name, invoice_number_preview, payment_remit_to, custom_text_above, custom_text_below} = this.state;
         let invoiceSetupId_data = 0 ;
       
       if(this.state.invoiceSetupId =='' ||this.state.invoiceSetupId === 0){
        invoiceSetupId_data = 0
       }
       else{
        invoiceSetupId_data = this.state.invoiceSetupId
       }

        var saveTemplateData = {
           "invoiceSetupId":invoiceSetupId_data,
          "logoSrc": image_name,
          "invoicePrefix":invoice_number_preview,
          "remitToAddress":payment_remit_to,
          "aboveInvoiceText": custom_text_above,
          "belowInvoiceText": custom_text_below
        };
       this.props.PutInvoiceTemplate(saveTemplateData);
       this.PrepareInvoice();
       }

    /* Redirect Back to Prepare Invoice */

    PrepareInvoice(){
        this.setState({
            PrepareInvoiceRedirect: true
        });
    }
       


    _handleImageChange(e) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            this.setState({
                image_name: file.name,
                file: file,
                imagePreviewUrl: reader.result
            },()=>{
                const data = new FormData();
                data.append('file', file);
                this.props.PostInvoiceLogo(data);
            });
        }
       reader.readAsDataURL(file)

    }


    render(response_from_reducer) {
        if (this.state.PrepareInvoiceRedirect) {
            return <Redirect to={"/Invoices/prepareinvoices"} />
        }
        let { imagePreviewUrl, image_name, invoice_number_preview, payment_remit_to, custom_text_above, custom_text_below,
             placeholder_invoice_number_preview,placeholder_payment_remit_to , placeholder_custom_text_above, placeholder_custom_text_below
        } = this.state;
        let $imagePreview;


        (imagePreviewUrl)? $imagePreview = (<img src={imagePreviewUrl} className="imgPreview" />)  :  $imagePreview = (<img src={NoImage} className="imgPreview" />);

        return (
            <div className="main_container">
                <h2 className="page_title inv_pagetitle">Customize Invoice</h2>

                <div className="invoice_container">
                    <p className="error_msg">  Customize this invoice template for your needs. Any field can be left blank and will not be included when invoices are generated.</p>

                    {/*Customise  Invoice  */}

                    <div className="customise_form">

                        <legend className="invoice_sub_title form_sub_title">Custom Logo </legend>

                        <div className="inv_form_group ">
                            <input ref='New_Tenant_Name' value={image_name} className="invoice_custom_log_input default-input" placeholder={ "Browser to upload an image file"} />

                            <label className="custom-file-upload btn btn-black inv_btn" >
                                <input type="file" onChange={(e) => this._handleImageChange(e)} />
                                <i className="fa fa-cloud-upload"></i> Browse...
                            </label>
                        </div>

                        <div className="inv_form_group">
                            <legend className="invoice_sub_title form_sub_title">Invoice Number Prefix </legend>
                            <span> <input className="default-input inv_num_prefix-1" type="text" maxLength="12" name="Invoice Number Prefix" placeholder={placeholder_invoice_number_preview} defaultValue={invoice_number_preview}  onChange={e => this.setState({ invoice_number_preview: e.target.value })} /> - NNNN </span>
                        </div>

                        <div className="inv_form_group">
                            <legend className="invoice_sub_title form_sub_title">Payment Address</legend>
                            <legend className="invoice_sub_title form_sub_title secondary">Remit to:</legend>
                            <textarea className="invoice_custom_textarea default-input" rows="2" onChange={e => this.setState({ payment_remit_to: e.target.value })}   value={this.state.payment_remit_to}  placeholder={placeholder_payment_remit_to}></textarea>
                        </div>

                        <legend className="invoice_sub_title form_sub_title">Custom Text </legend>
                        <div className="inv_form_group">
                            <legend className="invoice_sub_title form_sub_title secondary">Text above Invoice Detail </legend>
                            <textarea className="invoice_textarea default-input" onChange={e => this.setState({ custom_text_above: e.target.value })} rows="3"  value={this.state.custom_text_above}  placeholder={placeholder_custom_text_above} ></textarea>
                        </div>

                        <div className="inv_form_group">
                            <legend className="invoice_sub_title form_sub_title secondary">Text below Invoice Total </legend>
                            <input className="invoice_custom_textarea text default-input" onChange={e => this.setState({ custom_text_below: e.target.value })} type="text" ref='Tenant_Billing_Address'  value={this.state.custom_text_below} placeholder={placeholder_custom_text_below}  />
                        </div>

                        <div className="buttons_container">
                            <Button type="button" className="btn btn-gray inv_btn"  onClick={this.PrepareInvoice}>Cancel </Button>
                            <Button type="button" className="btn btn-success inv_btn" onClick={this.Save_Invoice_Template} >Save</Button>
                        </div>
                    </div>



                    {/* Invoice Preview */}
                    <div className="customise_form">
                        <legend className="invoice_sub_title form_sub_title">Invoice Preview</legend>
                    </div>
                        <div className="preview_form">
                        {/* <legend className="invoice_sub_title form_sub_title">Invoice Preview</legend> */}
                            <div className="preview_div preview_div_1">

                                <div className="imgPreview_div">
                                    {$imagePreview}
                                </div>

                                <div className="imgPreview_div2" >
                                    <div className="Invoice_form_group">
                                        <Label className="Invoice_Custom_label">Invoice Number :</Label>
                                        <span className="Invoice_Custom_input_val"> <input className="default-input inv_num_prefix" placeholder="ABC2015" disabled type="text" defaultValue={invoice_number_preview} ref='Tenant_Billing_Address' /> - NNNN </span>
                                    </div>
                                    <div className="Invoice_form_group ">
                                        <Label className="Invoice_Custom_label">Invoice Date :</Label>
                                        <Label className="Invoice_Custom_label_val">Month DD, Year</Label>
                                    </div>
                                    <div className="Invoice_form_group ">
                                        <Label className="Invoice_Custom_label">Billing Period :</Label>
                                        <Label className="Invoice_Custom_label_val">MM/DD - MM/DD/YY </Label>
                                    </div>
                                </div>
                            </div>


                            <div className="preview_div preview_div_2">
                                <div className="invoice_remit_to width_40">
                                    <legend className="invoice_sub_title form_sub_title">Remit To:</legend>
                                    <textarea className="remit_to_input" rows="2" value={payment_remit_to} readOnly placeholder="Property Mgmt Company Contact Name Street Address City, ST ZIP"></textarea>
                                </div>

                                <div className="invoice_remit_to_2 width_60">
                                    <legend className="invoice_sub_title form_sub_title">Bill To: </legend>
                                    <div className="bill_to_input ">
                                        <p>Tenant Name & Address Filled in Automatically</p>
                                    </div>
                                </div>
                            </div>
                            <textarea className="preview_div preview_div_3" rows="2" value={custom_text_above} readOnly  placeholder="Here is your invoice for after hours during the contract period." ></textarea>
                           
                            <legend className="invoice_sub_title form_sub_title">Invoice Detail </legend>

                            <div className="preview_div preview_div_4">
                                <p>The After Hours change requests table, with billing rate and total charges, will automatically populate for each tenant when the invoice is generated.</p>
                            </div>

                            <legend className="invoice_sub_title form_sub_title preview_div preview_div_5">Invoice Total :  <span>NN,NNN.NN </span>	</legend>
                            <textarea className="preview_div preview_div_6" rows="2" value={custom_text_below} readOnly placeholder="Terms are Net 60"   ></textarea>

                        </div>


                    {/* </div> */}
                </div>

            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        response_from_reducer: state.InvoiceRootReducer,         //Fetching Invoice Template data from State
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference         //Fetching data from resource files
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getUserPreferences: () => dispatch(getUserPreferences()),
        GetInvoiceTemplate: () => dispatch(GetInvoiceTemplate()),
        GetInvoiceLogo: () => dispatch(GetInvoiceLogo()),
        PostInvoiceLogo: (imagefile) => dispatch(PostInvoiceLogo(imagefile)),
        PutInvoiceTemplate: (data) => dispatch(PutInvoiceTemplate(data)),
        
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomiseInvoices);